// Port of api/fuel/app/classes/filter/search/games/sorts/query/rating/community/gap.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'

function getActiveName(filter) {
	if (sorted('rating.gap', filter) > 0) return 'rating.gap'
	if (sorted('rating.gap.bgg', filter) > 0) return 'rating.gap.bgg'
	return null
}

export default {
	name: 'rating.gap.*',
	post: false,
	require: function(config, filter) { return getActiveName(filter) !== null },
	run: function(config, filter, data, query) {
		var name = getActiveName(filter)
		query.where('g.game_rating_avg', '>', 0)
		query.order('ABS(AVG(r.rating_value) - g.game_rating_avg)', sortReverse(name, filter), sortPriority(name, filter))
	}
}
